var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[_vm.computedLabbold]},[_vm._v("\n  "+_vm._s(_vm.LabText)),_c('br'),_vm._t("small")],2)}
var staticRenderFns = []

export { render, staticRenderFns }